import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
} from '@radix-ui/react-accordion';

import { css, styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const Root = styled(Accordion)<{ $size: 'small' | 'large' }>`
  ${({ $size }) =>
    $size === 'small' &&
    css`
      box-shadow: 0 0.25rem 0.5rem 0 rgba(16, 114, 186, 0.16);
    `};
  border-radius: ${BorderRadius.S};
  min-width: 25rem;
`;

export const Item = styled(AccordionItem)`
  background-color: ${Colors.white};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.S};
  overflow: hidden;
`;

export const Header = styled(AccordionHeader)`
  align-items: center;
  display: flex;
  margin: 0;
`;

export const Trigger = styled(AccordionTrigger)<{ $size: 'small' | 'large' }>`
  align-items: center;
  background-color: ${Colors.blue[3]};
  border: none;
  border-bottom: ${({ $size }) => ($size === 'large' ? `none` : `1px solid ${Colors.blue[20]}`)};
  border-radius: ${BorderRadius.S} ${BorderRadius.S} 0 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: ${({ $size }) => ($size === 'large' ? Spacing.S : `${Spacing.Xs} ${Spacing.S}`)};
  width: 100%;

  > div {
    align-items: center;
    display: flex;
    gap: ${Spacing.Xs};
  }

  > svg {
    color: ${Colors.blue[100]};
  }

  &[data-state='open'] > svg {
    transform: rotate(180deg);
  }
`;

export const Content = styled(AccordionContent)`
  overflow: hidden;
  padding: 2rem;
`;
